import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { RichText } from 'src/components/RichText/RichText';
import imgFallback from 'src/utils/image';
import * as classes from './FlowListingItem.module.scss';

export const FlowListingItem = ({
  title,
  description,
  listingColumnTitle,
  listingColumnItems,
  infoColumnTitle,
  infoColumnItems,
  image,
  index,
}) => {
  const currentIndex = index + 1;

  const hasListingColumn = listingColumnTitle && listingColumnItems.length;
  const hasInfoColumn = infoColumnTitle && infoColumnItems.length;

  const getMainContentWidth = () => {
    if ((hasListingColumn && !hasInfoColumn) || (!hasListingColumn && hasInfoColumn)) return 8;
    if (!hasListingColumn && !hasInfoColumn) return 12;
    return 5;
  };

  return (
    <div className={classes.container}>
      <Row className={classes.index}>
        {currentIndex < 10 && '0'}
        {currentIndex}
      </Row>
      <Row className={classes.wrapper}>
        <Col xs={12} md={getMainContentWidth()}>
          <Row className={classes.sectionTitle}>{title}</Row>
          <Row className={classes.description}>
            <RichText content={description} />
          </Row>
        </Col>
        {listingColumnItems.length && listingColumnTitle ? (
          <Col xs={12} md={3}>
            <Row className={classes.sectionTitle}>{listingColumnTitle}</Row>
            <ul className={classes.list}>
              {React.Children.toArray(
                listingColumnItems.map((e) => (
                  <li>
                    <span className={classes.listItem}>{e}</span>
                  </li>
                ))
              )}
            </ul>
          </Col>
        ) : null}
        {listingColumnItems.length && listingColumnTitle ? (
          <Col xs={12} md={3}>
            <Row className={classes.sectionTitle}>{infoColumnTitle}</Row>
            {React.Children.toArray(infoColumnItems.map((e) => <Row className={classes.info}>{e}</Row>))}
          </Col>
        ) : null}
      </Row>
      <GatsbyImage alt={image?.alt ?? ''} image={image?.image?.asset?.gatsbyImageData ?? imgFallback} className={classes.image} />
    </div>
  );
};
